import { render, staticRenderFns } from "./DonationsSummary.vue?vue&type=template&id=330db01a"
import script from "./DonationsSummary.vue?vue&type=script&lang=js"
export * from "./DonationsSummary.vue?vue&type=script&lang=js"
import style0 from "./DonationsSummary.vue?vue&type=style&index=0&id=330db01a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports